import { render, staticRenderFns } from "./SettingGps.vue?vue&type=template&id=1930d444&"
import script from "./SettingGps.vue?vue&type=script&lang=js&"
export * from "./SettingGps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports